import zodiacDescriptionsChange from './actions/zodiacDescriptionsChange';
import zodiacDescriptionsCreate from './actions/zodiacDescriptionsCreate';
import zodiacDescriptionsDetail from './actions/zodiacDescriptionsDetail';
import zodiacDescriptionsList from './actions/zodiacDescriptionsList';
import getZodiacDescriptions from './getters/getZodiacDescriptions';
import zodiacDescriptionsUpload from './mutations/zodiacDescriptionsUpload';

const actions = {
    zodiacDescriptionsChange,
    zodiacDescriptionsCreate,
    zodiacDescriptionsDetail,
    zodiacDescriptionsList
};

const mutations = {
    zodiacDescriptionsUpload
};

const getters = {
    getZodiacDescriptions
};

export default { actions, mutations, getters };
